/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AspenAuditEntityType } from '../models/AspenAuditEntityType'
import type { AuditChangeType } from '../models/AuditChangeType'
import type { AuditOperation } from '../models/AuditOperation'
import type { PaginatedDTO_AuditChangeLogResponseDTO_ } from '../models/PaginatedDTO_AuditChangeLogResponseDTO_'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class AspenAuditLogsService {
    /**
     * Index
     * Get a paginated list of audit logs.
     *
     * Supports filtering by:
     * - entity_type: Filter by entity type (e.g., patient, candidate)
     * - entity_id: Filter by specific entity ID
     * - user_id: Filter by user who made the change
     * - start_date: Filter by start date (inclusive)
     * - end_date: Filter by end date (inclusive)
     * - operation: Filter by operation type (C=Create, U=Update, D=Delete, T=Truncate)
     * - change_type: Filter by change source (APPLICATION_EVENT, DATABASE_TRIGGER, SYSTEM_JOB)
     *
     * Results are ordered by created_dttm descending (most recent first).
     * RLS automatically enforces organization isolation.
     * @returns PaginatedDTO_AuditChangeLogResponseDTO_ Successful Response
     * @throws ApiError
     */
    public static indexAuditLogsGet({
        entityType,
        entityId,
        userId,
        startDate,
        endDate,
        operation,
        changeType,
        page = 1,
        limit = 20
    }: {
        /**
         * Filter by entity type
         */
        entityType?: AspenAuditEntityType | null
        /**
         * Filter by entity ID
         */
        entityId?: string | null
        /**
         * Filter by user ID
         */
        userId?: string | null
        /**
         * Filter by start date (inclusive)
         */
        startDate?: string | null
        /**
         * Filter by end date (inclusive)
         */
        endDate?: string | null
        /**
         * Filter by operation (C/U/D/T)
         */
        operation?: AuditOperation | null
        /**
         * Filter by change type
         */
        changeType?: AuditChangeType | null
        /**
         * Page number
         */
        page?: number
        /**
         * Items per page
         */
        limit?: number
    }): CancelablePromise<PaginatedDTO_AuditChangeLogResponseDTO_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/audit-logs',
            query: {
                entity_type: entityType,
                entity_id: entityId,
                user_id: userId,
                start_date: startDate,
                end_date: endDate,
                operation: operation,
                change_type: changeType,
                page: page,
                limit: limit
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Get Entity Logs
     * Get audit logs for a specific entity.
     *
     * Returns all change logs for the specified entity_type and entity_id.
     * Supports additional filtering by user_id, date range, operation, and change_type.
     *
     * Results are ordered by created_dttm descending (most recent first).
     * RLS automatically enforces organization isolation.
     * @returns PaginatedDTO_AuditChangeLogResponseDTO_ Successful Response
     * @throws ApiError
     */
    public static getEntityLogsAuditLogsEntityTypeEntityIdGet({
        entityType,
        entityId,
        userId,
        startDate,
        endDate,
        operation,
        changeType,
        page = 1,
        limit = 20
    }: {
        entityType: AspenAuditEntityType
        entityId: string
        /**
         * Filter by user ID
         */
        userId?: string | null
        /**
         * Filter by start date (inclusive)
         */
        startDate?: string | null
        /**
         * Filter by end date (inclusive)
         */
        endDate?: string | null
        /**
         * Filter by operation (C/U/D/T)
         */
        operation?: AuditOperation | null
        /**
         * Filter by change type
         */
        changeType?: AuditChangeType | null
        /**
         * Page number
         */
        page?: number
        /**
         * Items per page
         */
        limit?: number
    }): CancelablePromise<PaginatedDTO_AuditChangeLogResponseDTO_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/audit-logs/{entity_type}/{entity_id}',
            path: {
                entity_type: entityType,
                entity_id: entityId
            },
            query: {
                user_id: userId,
                start_date: startDate,
                end_date: endDate,
                operation: operation,
                change_type: changeType,
                page: page,
                limit: limit
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Get Subject History
     * Get complete audit history for a subject (candidate, patient, or care-partner).
     *
     * This endpoint fetches all related audit logs including:
     * - Main entity audit logs (candidate/patient/care-partner)
     * - All contact attempt audit logs for that subject
     * - Care partner audit logs (if the subject has an associated care partner, for candidates/patients only)
     * - Ciox request audit logs (for patients only, if they have associated ciox requests)
     *
     * This is more efficient than making separate API calls for each entity type.
     *
     * Args:
     * subject_type: Either "candidate", "patient", or "care-partner"
     * subject_id: The UUID of the candidate, patient, or care-partner
     * user_id: Filter by user who made the change
     * start_date: Filter by start date (inclusive)
     * end_date: Filter by end date (inclusive)
     * operation: Filter by operation type (C=Create, U=Update, D=Delete, T=Truncate)
     * change_type: Filter by change source (APPLICATION_EVENT, DATABASE_TRIGGER, SYSTEM_JOB)
     * sort: Sort by field:order (e.g., 'created_dttm:desc', 'operation:asc').
     * Supported fields: created_dttm, operation, entity_type, created_by_email.
     * Default: 'created_dttm:desc'
     * page: Page number (default: 1)
     * limit: Items per page (default: 20, max: 100)
     *
     * Returns:
     * Paginated list of all audit logs for the subject, ordered by specified sort or created_dttm desc.
     * @returns PaginatedDTO_AuditChangeLogResponseDTO_ Successful Response
     * @throws ApiError
     */
    public static getSubjectHistoryAuditLogsSubjectSubjectTypeSubjectIdGet({
        subjectType,
        subjectId,
        userId,
        startDate,
        endDate,
        operation,
        changeType,
        sort,
        page = 1,
        limit = 20
    }: {
        subjectType: string
        subjectId: string
        /**
         * Filter by user ID
         */
        userId?: string | null
        /**
         * Filter by start date (inclusive)
         */
        startDate?: string | null
        /**
         * Filter by end date (inclusive)
         */
        endDate?: string | null
        /**
         * Filter by operation (C/U/D/T)
         */
        operation?: AuditOperation | null
        /**
         * Filter by change type
         */
        changeType?: AuditChangeType | null
        /**
         * Sort by field:order (e.g., 'created_dttm:desc', 'operation:asc'). Supported fields: created_dttm, operation, entity_type, created_by_email. Default: 'created_dttm:desc'
         */
        sort?: string | null
        /**
         * Page number
         */
        page?: number
        /**
         * Items per page
         */
        limit?: number
    }): CancelablePromise<PaginatedDTO_AuditChangeLogResponseDTO_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/audit-logs/subject/{subject_type}/{subject_id}',
            path: {
                subject_type: subjectType,
                subject_id: subjectId
            },
            query: {
                user_id: userId,
                start_date: startDate,
                end_date: endDate,
                operation: operation,
                change_type: changeType,
                sort: sort,
                page: page,
                limit: limit
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
}
